<template>
  <div id="COApplicationForRegistered">
    <section>
      <div id="container-center">
        <h1
          class="title is-3 has-text-centered"
        >ケア オーケストレーター 利用申込み</h1>
        <div>
          <div id="item-contens" style="width:720px">
            <div class="card-content margin-top" >
              <h2 class="title is-4" style="text-align:center;">
                登録の申し込みが完了しました。
              </h2>
              <p style="text-align:left">
                ※システムへの登録が完了しましたら、登録済みメールアドレス宛に登録完了メールが送付されます。
                <br><br>
                ※引き続きケア　オーケストレーターをご利用になれます。
              </p>
            </div>
            <div class="margin-top">
              <b-button class="backbutton is-primary" @click="back">戻る</b-button>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import {role} from "@/components/mock/base/const.js";
export default {
  name: "COApplicationForRegistered",
  methods: {
    back: function() {
      //登録待ちの状態をユーザー情報にセット
      this.userInfo.coType = 1
      this.userInfo.coInUse = 2
      sessionStorage.setItem('userInfo', JSON.stringify(this.userInfo))
      this.$router.push({
        name:this.userInfo.roleId == role.role_dealer?"CODealerMenu":"guestHome"
      });
    },
  },
  data() {
    var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    return {
      userInfo:userInfo,
    };
  },
  computed: {}
};
</script>



// WEBPACK FOOTER //
// src/components/mock/guest/careorchestrator/COApplicationForRegistered.vue